// extracted by mini-css-extract-plugin
export default {"textInputBox":"TextInput_textInputBox__8-9w-","inputMain":"TextInput_inputMain__pxTqx","iconSize":"TextInput_iconSize__4aMHf","hide":"TextInput_hide__oQ2X4"};